// ⛔ ÍCONES DESENHADOS, não emojis.
// Um emoji muda de cara em cada telemóvel e em cada sistema, e o 💬 saía diferente no iPhone,
// no Android e no Windows. Estes são sempre iguais, herdam a cor de onde estão, e pesam menos
// do que uma imagem.
const ICONE_CONVERSA = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>';
const ICONE_ENVIAR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h13M12 5l7 7-7 7"/></svg>';
const ICONE_FECHAR = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';
const ICONE_APAGAR = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6"/></svg>';
const ICONE_AUMENTAR = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/></svg>';
const ICONE_AVISO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></svg>';

const ENDPOINT = '/apps/sereia/perguntar';
const ENDPOINT_RESPOSTAS = '/apps/sereia/respostas';
const ENDPOINT_MODO = '/apps/sereia/modo';
const CHAVE_CONVERSA = 'sereia-conversa-id';
const CHAVE_MENSAGENS = 'sereia-mensagens';
const CHAVE_POSICAO_BOLHA = 'sereia-posicao-bolha';
const CHAVE_PRIMEIRO_ARRASTO = 'sereia-primeiro-arrasto';
const CHAVE_ULTIMA_UTILIZACAO = 'sereia-ultima-utilizacao';
const CHAVE_RESPOSTA_LIDA = 'sereia-resposta-lida-';
const TIMEOUT_MS = 20000;
const DIAS_PRAZO_CONVERSA = 30;
const LIMITE_MENSAGENS = 50;
const INTERVALO_RESPOSTAS_MS = 15000; // 15 segundos
const MAX_TEMPO_ESPERA_RESPOSTAS_MS = 30 * 60 * 1000; // 30 minutos
// ⛔ SEM «tu», SEM «você» e SEM exclamação, como tudo o que a casa escreve
// (`ILHA-COMO-SE-ESCREVE.md`). ⚠️ E sem pronome colado: «ajudar-te» virou «ajudar».
// Pedido da Proa a 09/10/2026, da auditoria do tema novo.
const MENSAGEM_BOAS_VINDAS = 'Olá, sou a Sereia, a assistente da Ilha dos Cosméticos. Falo por inteligência artificial. Posso ajudar a encontrar o produto certo, a ver como está uma encomenda ou a tirar dúvidas sobre a loja. Em que posso ajudar?';
const SUGESTOES = [
  'Que produtos tenho para cabelo cacheado?',
  'Onde está a minha encomenda?',
  'Quanto custa o envio?'
];

let ecraTodoAberto = false;
let conversaId = null;
/** ⚠️ Pista de contexto vinda de um link (ex.: o email da encomenda). Nunca se mostra à cliente. */
let pistaDaEncomenda = null;

// ⛔⛔ O MODO: a Sereia responde sozinha, ou isto é só uma caixa de recados?
// Ordem do Silva de 10/10/2026. A bolha mostra a saudação ANTES de a cliente escrever, e a de
// sempre promete «posso ajudar a encontrar o produto certo». Com a inteligência desligada isso
// é mentira: quem responde é uma pessoa, e pode não ser agora. Pergunta-se ao servidor AO ABRIR
// (não no carregamento da página: seria um pedido por cada visita a cada página da loja).
// ⚠️ `null` quer dizer «ainda não sei», e aí mostra-se a saudação de sempre.
let modoRecado = null;
let boasVindasDoRecado = null;

// ⚠️ A saudação de recurso, para quando o servidor não respondeu. ⛔ Não diz horas nem dias: isso
// só o servidor sabe, e aqui inventar-se-ia.
const BOAS_VINDAS_SEM_SABER = 'Olá, sou a Sereia, da Ilha dos Cosméticos. As respostas aqui são escritas por uma pessoa da equipa. Deixa aqui a mensagem e respondemos o mais breve possível.';

/**
 * ⛔⛔ FALHA FECHADA, e isto estava ao contrário.
 *
 * A primeira escrita deixava o modo em «não sei» quando o pedido falhava, e «não sei» mostrava a
 * saudação de sempre: «Falo por inteligência artificial. Posso ajudar a encontrar o produto
 * certo…» A auditoria de regressão de 11/10/2026 mediu-o com o `/modo` a devolver 500, com o
 * servidor em recado: a bolha prometia respostas automáticas que ninguém ia dar.
 * ⭐ Agora, se não se consegue saber, assume-se RECADO, que é o lado seguro e é também o modo por
 * omissão do servidor. Uma bolha que diz «uma pessoa responde» quando por acaso o robô estava
 * ligado só perde uma comodidade; ao contrário, promete-se o que não se cumpre.
 * ⚠️ E o prazo é curto (2 segundos): a saudação só aparece depois disto, e com 6 segundos quem
 * escrevesse logo via a saudação a aparecer DEPOIS da própria mensagem.
 */
async function saberOModo() {
  if (modoRecado !== null) return;
  try {
    const r = await fetch(ENDPOINT_MODO, { signal: AbortSignal.timeout(2000) });
    if (!r.ok) throw new Error(String(r.status));
    const d = await r.json();
    modoRecado = d && d.recado === true;
    boasVindasDoRecado = d && typeof d.boasVindas === 'string' && d.boasVindas.trim()
      ? d.boasVindas.trim()
      : null;
  } catch (e) {
    // ⛔ Falha fechada: na dúvida, é recado.
    modoRecado = true;
    boasVindasDoRecado = BOAS_VINDAS_SEM_SABER;
  }
}


/** A saudação que se mostra: a do recado quando o servidor a mandou, a de sempre no resto. */
function saudacao() {
  return modoRecado && boasVindasDoRecado ? boasVindasDoRecado : MENSAGEM_BOAS_VINDAS;
}

/**
 * ⛔ A FAIXA DO TOPO TEM DE DIZER A VERDADE.
 *
 * Ela está sempre à vista e dizia «Falo por inteligência artificial» mesmo com a inteligência
 * desligada, dois centímetros acima de «As respostas aqui são escritas por uma pessoa da equipa».
 * A auditoria de regressão de 11/10/2026 apanhou-a numa captura. Agora troca com o modo.
 */
function acertarAFaixa() {
  const texto = document.getElementById('sereia-faixa-texto');
  if (!texto) return;
  texto.textContent = modoRecado
    ? 'Quem responde aqui é uma pessoa da equipa'
    : 'Falo por inteligência artificial';
}
let aEspera = false;
let emArrasto = false;
let ultimoArrastoEm = 0;
let pontoInicial = { x: 0, y: 0 };
let posicaoBolha = { x: 0, y: 0 };
let jaShowuBemVindo = false;
let pollingRespostas = null;
let aoVoltarAoSeparador = null;
let inicioPollingRespostas = 0;
let ultimasRespostasLidas = [];

function verificarPrazoConversa() {
  const u = localStorage.getItem(CHAVE_ULTIMA_UTILIZACAO);
  if (!u) return;
  const d = Math.floor((Date.now() - parseInt(u, 10)) / (1000 * 60 * 60 * 24));
  if (d >= DIAS_PRAZO_CONVERSA) apagarConversa();
}
function atualizarUltimaUtilizacao() { localStorage.setItem(CHAVE_ULTIMA_UTILIZACAO, Date.now().toString()); }
function apagarConversa() {
  localStorage.removeItem(CHAVE_CONVERSA);
  localStorage.removeItem(CHAVE_MENSAGENS);
  localStorage.removeItem(CHAVE_ULTIMA_UTILIZACAO);
  const c = document.getElementById('sereia-mensagens');
  if (c) c.innerHTML = '';
  jaShowuBemVindo = false;

  // A conversa comeca de novo, e por isso precisa de um identificador novo: continuar com
  // o antigo colava a conversa apagada a seguinte no registo do servidor.
  conversaId = crypto.randomUUID?.() || gerarId();
  localStorage.setItem(CHAVE_CONVERSA, conversaId);
  atualizarUltimaUtilizacao();

  // ⚠️ E o ecra NAO pode ficar em branco. Apagar a conversa deixava a cliente a olhar para
  // um espaco vazio, que e o mesmo defeito que o widget ja tinha ao abrir pela primeira vez.
  // Volta tudo ao principio: a Sereia apresenta-se e as sugestoes voltam.
  acertarAFaixa();
  mostrarMensagem(saudacao(), 'sereia');
  if (!modoRecado) mostrarSugestoes();
  jaShowuBemVindo = true;
}

function inicializar() {
  // ⚠️ A GUARDA DO ARRANQUE DUPLO, e esta ja falhou.
  // Antes procurava `sereia-widget`, um id que o widget NUNCA cria. A guarda nunca travava
  // nada e, se o ficheiro fosse carregado duas vezes (dois <script> no tema, um recarregar
  // parcial), nascia tudo a dobrar: duas bolhas, dois ecras, os botoes com dois ouvintes, e a
  // saudacao a aparecer duas vezes. Agora procura um id que EXISTE mesmo.
  if (document.getElementById('sereia-botao-bolha') || window.__sereiaJaArrancou) return;
  window.__sereiaJaArrancou = true;

  verificarPrazoConversa();

  conversaId = localStorage.getItem(CHAVE_CONVERSA) || crypto.randomUUID?.() || gerarId();
  localStorage.setItem(CHAVE_CONVERSA, conversaId);

  atualizarUltimaUtilizacao();

  const html = `
    <button class="sereia-bolha" id="sereia-botao-bolha" aria-label="Falar com a Sereia" title="Alguma dúvida?">
      ${ICONE_CONVERSA}
    </button>

    <div class="sereia-ecra" id="sereia-ecra" hidden role="dialog" aria-label="Conversa com a Sereia">
      <div class="sereia-cabecalho">
        <div class="sereia-marca">
          <span class="sereia-gota" aria-hidden="true">${ICONE_CONVERSA}</span>
          <span>
            <h2 class="sereia-titulo">Sereia</h2>
            <p class="sereia-subtitulo">Ilha dos Cosméticos</p>
          </span>
        </div>
        <div class="sereia-botoes-cabecalho">
          <button class="sereia-aumentar" id="sereia-botao-aumentar" aria-label="Aumentar a janela" title="Aumentar">${ICONE_AUMENTAR}</button>
          <button class="sereia-apagar" id="sereia-botao-apagar" aria-label="Apagar esta conversa" title="Apagar">${ICONE_APAGAR}</button>
          <button class="sereia-fechar" id="sereia-botao-fechar" aria-label="Fechar" title="Fechar">${ICONE_FECHAR}</button>
        </div>
      </div>

      <div class="sereia-aviso" id="sereia-faixa-aviso">
        ${ICONE_AVISO}
        <span id="sereia-faixa-texto">Falo por inteligência artificial</span>
      </div>

      <div class="sereia-corpo">
        <div class="sereia-mensagens" id="sereia-mensagens"></div>
      </div>

      <div class="sereia-rodape">
        <textarea
          class="sereia-entrada"
          id="sereia-entrada"
          placeholder="Escreve aqui a pergunta"
          rows="1"
          aria-label="A pergunta"
        ></textarea>
        <button class="sereia-enviar" id="sereia-botao-enviar" aria-label="Enviar pergunta">
          ${ICONE_ENVIAR}
        </button>
      </div>
    </div>
  `;

  document.body.insertAdjacentHTML('beforeend', html);
  injetarCss();

  const botaoBolha = document.getElementById('sereia-botao-bolha');
  const botaoFechar = document.getElementById('sereia-botao-fechar');
  const botaoApagar = document.getElementById('sereia-botao-apagar');
  const botaoAumentar = document.getElementById('sereia-botao-aumentar');
  const botaoEnviar = document.getElementById('sereia-botao-enviar');
  const entrada = document.getElementById('sereia-entrada');

  botaoBolha?.addEventListener('click', abrir);
  botaoBolha?.addEventListener('pointerdown', iniciarArrasto);
  botaoBolha?.addEventListener('pointermove', arrastarBolha);
  botaoBolha?.addEventListener('pointerup', terminarArrasto);
  botaoBolha?.addEventListener('pointercancel', terminarArrasto);

  botaoFechar?.addEventListener('click', fechar);
  botaoApagar?.addEventListener('click', mostrarConfirmacaoApagar);
  botaoAumentar?.addEventListener('click', alternarTamanho);
  botaoEnviar?.addEventListener('click', enviar);
  entrada?.addEventListener('keypress', (e) => { if (e.key === 'Enter' && !e.shiftKey && !aEspera) { e.preventDefault(); enviar(); } });
  entrada?.addEventListener('input', ajustarAltura);
  window.addEventListener('resize', ajustarPosicaoBolhaNoRedimensionar);
  restaurarPosicaoBolha();

  const mensagensGuardadas = localStorage.getItem(CHAVE_MENSAGENS);
  if (mensagensGuardadas) {
    try {
      const msgs = JSON.parse(mensagensGuardadas);
      const container = document.getElementById('sereia-mensagens');
      for (const msg of msgs) {
        const div = document.createElement('div');
        div.className = `sereia-msg sereia-msg--${msg.tipo}`;
        div.textContent = msg.texto;
        container.appendChild(div);
      }
      jaShowuBemVindo = true;
      if (container) {
        const scroll = container;
        scroll.scrollTop = scroll.scrollHeight;
      }
    } catch (e) {
    }
  }

  abrirPorLinkDeFora();
}

/**
 * ⭐ O LINK DE FORA: `?sereia=abrir` abre a bolha sozinha.
 *
 * É o que faz um email, um SMS ou um post levarem a cliente a falar connosco sem passar pelo
 * WhatsApp. Decisão do Silva a 23/09/2026: *«tudo nosso é link do chat nosso, para a gente não
 * estar pagando mais ainda»* — cada mensagem do WhatsApp é paga à Meta, a bolha não é.
 *
 * ⚠️ UMA VEZ SÓ, e o parâmetro sai do endereço: sem isso, recarregar a página ou voltar atrás
 * reabria a bolha por cima do que a cliente estivesse a fazer, e o endereço ficava com um
 * parâmetro nosso colado para sempre, inclusive se ela o partilhasse.
 *
 * ⛔ O `&encomenda=` é uma PISTA, não um dado: serve para a equipa saber de que encomenda se
 * fala. Não se mostra nada à cliente com ele, e não se vai buscar nada com ele.
 */
function abrirPorLinkDeFora() {
  try {
    const endereco = new URL(window.location.href);
    if (endereco.searchParams.get('sereia') !== 'abrir') return;

    const encomenda = endereco.searchParams.get('encomenda');
    if (encomenda && /^[0-9A-Za-z#-]{1,32}$/.test(encomenda)) pistaDaEncomenda = encomenda;

    // ⚠️ Tira os parâmetros ANTES de abrir: se o abrir falhar, o endereço fica limpo na mesma.
    endereco.searchParams.delete('sereia');
    endereco.searchParams.delete('encomenda');
    window.history.replaceState({}, '', endereco.pathname + (endereco.search || '') + endereco.hash);

    abrir();
  } catch (e) {
    // Um endereço estranho não pode partir a bolha.
  }
}

/**
 * ⛔ A ALTURA DA FOLHA VEM DO `visualViewport`, E E A UNICA MEDIDA QUE DESCE COM O TECLADO.
 *
 * No iPhone, o teclado nao encolhe o `100dvh`: o `dvh` serve para a barra do Safari aparecer e
 * desaparecer. O painel ficava a achar que tinha o ecra todo, o teclado subia por cima, e a caixa
 * de escrever ia parar debaixo dele. O Silva disse: *«quando eu coloco para escrever a mensagem, o
 * texto fica estourado, a conversa fica cortando na metade do telefone. Eu ajusto, mas depois ela
 * estoura de novo»* (03/10/2026). O «ajusto e volta» e o `dvh` a recalcular quando a barra do
 * Safari muda, que dava um instante de folga e perdia-se no teclado seguinte.
 *
 * ⚠️ `--sereia-fundo` e o que o teclado tapa, e levanta a folha para cima dele.
 * ⚠️ Com o teclado aberto deixa-se so 8px de folga em cima: o que sobra e pouco e nao se deita
 *    fora. Fechado, deixam-se 56px, para se VER a loja por tras, que foi o pedido.
 * ⛔ So no telemovel: a partir dos 768px a folha volta a ser janela e estas medidas saem.
 */
const FOLGA_DA_FOLHA = 56;

function medirAFolha() {
  const ecra = document.getElementById('sereia-ecra');
  if (!ecra) return;
  const vv = window.visualViewport;
  if (!vv || window.innerWidth >= 768) {
    ecra.style.removeProperty('--sereia-altura');
    ecra.style.removeProperty('--sereia-fundo');
    return;
  }
  // ⚠️ O que fica tapado em baixo: quase sempre o teclado. Nunca negativo.
  const tapado = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
  const tecladoAberto = tapado > 120;
  const folga = tecladoAberto ? 8 : FOLGA_DA_FOLHA;
  // ⛔ Um minimo, para a folha nunca ficar uma nesga onde nao cabe a conversa.
  const altura = Math.max(240, Math.round(vv.height - folga));
  ecra.style.setProperty('--sereia-altura', altura + 'px');
  ecra.style.setProperty('--sereia-fundo', tapado + 'px');
}

if (window.visualViewport) {
  window.visualViewport.addEventListener('resize', medirAFolha);
  window.visualViewport.addEventListener('scroll', medirAFolha);
}
window.addEventListener('orientationchange', () => setTimeout(medirAFolha, 120));
window.addEventListener('resize', medirAFolha);

function abrir() {
  // ⚠️ As travas do arrasto vem PRIMEIRO. Arrastar a bolha nao pode abrir a conversa, e uma
  // linha posta antes destas corria em todos os arrastos.
  if (emArrasto) return;
  if (Date.now() - ultimoArrastoEm < 300) return;

  aplicarTamanhoGuardado();
  atualizarUltimaUtilizacao();

  ecraTodoAberto = true;
  const ecra = document.getElementById('sereia-ecra');
  if (ecra) {
    ecra.removeAttribute('hidden');
    // ⛔ Medir ASSIM QUE ABRE: sem isto a folha nascia com a altura por omissao e so acertava ao
    // primeiro toque no teclado.
    medirAFolha();

    if (!jaShowuBemVindo) {
      jaShowuBemVindo = true;
      // ⚠️ Pergunta-se o modo e só depois se saúda, para não aparecer a frase errada e mudar
      // à frente dela. Se o servidor não responder, mostra-se a de sempre.
      saberOModo().then(() => {
        acertarAFaixa();
        mostrarMensagem(saudacao(), 'sereia');
        // ⛔ Com a inteligência desligada NÃO se mostram as perguntas sugeridas: cada uma delas
        // promete uma resposta imediata que não vem.
        if (!modoRecado) mostrarSugestoes();
      });
    }

    document.getElementById('sereia-entrada')?.focus();
  }
}

// ⚠️ So faz efeito no computador: a classe do tamanho grande vive dentro de uma media query
// de 768px para cima, e no telemovel o ecra continua inteiro, que e o que ali se quer.
// O tamanho escolhido fica guardado, para nao se ter de carregar aqui a cada visita.
const CHAVE_TAMANHO = 'sereia-janela-grande';

function aplicarTamanhoGuardado() {
  try {
    if (localStorage.getItem(CHAVE_TAMANHO) !== 'true') return;
    document.getElementById('sereia-ecra')?.classList.add('sereia-ecra--grande');
    marcarBotaoDeTamanho(true);
  } catch {}
}

// ⚠️ Só se mexe no rótulo, NUNCA no conteúdo do botão. A versão anterior fazia
// `b.textContent = '⤡'`, o que apagava o ícone desenhado e punha um emoji no lugar: bastava
// carregar uma vez para o botão deixar de combinar com os outros dois ao lado.
function marcarBotaoDeTamanho(grande) {
  const b = document.getElementById('sereia-botao-aumentar');
  if (!b) return;
  b.title = grande ? 'Diminuir' : 'Aumentar';
  b.setAttribute('aria-label', grande ? 'Diminuir a janela' : 'Aumentar a janela');
}

function alternarTamanho() {
  const e = document.getElementById('sereia-ecra');
  if (!e) return;
  const grande = e.classList.toggle('sereia-ecra--grande');
  marcarBotaoDeTamanho(grande);
  try { localStorage.setItem(CHAVE_TAMANHO, String(grande)); } catch {}
}

function fechar() {
  ecraTodoAberto = false;
  const e = document.getElementById('sereia-ecra');
  if (e) e.setAttribute('hidden', '');
}
function mostrarConfirmacaoApagar() {
  if (confirm('Apagar esta conversa? Não há como a trazer de volta.')) {
    apagarConversa();
  }
}

function mostrarMensagem(texto, tipo = 'sereia') {
  const c = document.getElementById('sereia-mensagens');
  if (!c) return;
  const v = c.querySelector('.sereia-vazio');
  if (v) v.remove();
  if (tipo === 'cliente') c.querySelector('.sereia-sugestoes')?.remove();
  const d = document.createElement('div');
  d.className = `sereia-msg sereia-msg--${tipo}`;
  d.textContent = texto;
  c.appendChild(d);
  c.scrollTop = c.scrollHeight;
  atualizarUltimaUtilizacao();
  // ⚠️ A saudacao NAO se guarda: e escrita pelo widget, nao e conversa. Guardada, uma cliente
  // que apagasse a conversa e voltasse encontrava a saudacao restaurada mas SEM as sugestoes,
  // porque estas so aparecem quando ainda nao houve saudacao nenhuma.
  // ⚠️ E vale para as DUAS saudações: a de sempre e a do modo de recado.
  if (texto === MENSAGEM_BOAS_VINDAS || (boasVindasDoRecado && texto === boasVindasDoRecado)) return;
  try {
    const m = JSON.parse(localStorage.getItem(CHAVE_MENSAGENS) || '[]');
    m.push({ texto, tipo });
    if (m.length > LIMITE_MENSAGENS) m.splice(0, m.length - LIMITE_MENSAGENS);
    localStorage.setItem(CHAVE_MENSAGENS, JSON.stringify(m));
  } catch (e) {}
}

/**
 * Os produtos que a Sereia citou, em cartão.
 *
 * ⛔ TUDO por `textContent` e por atributos, nunca por `innerHTML`. O que vem do servidor
 * é texto, e texto que se cola como HTML é por onde entra código de outra pessoa. A regra
 * vale mesmo sendo o nosso catálogo: é o hábito que protege, não a confiança.
 *
 * ⚠️ O link é sempre da nossa loja, e confirma-se antes de o pôr no `href`.
 */
function mostrarProdutos(produtos) {
  const c = document.getElementById('sereia-mensagens');
  if (!c || !Array.isArray(produtos) || produtos.length === 0) return;

  const caixa = document.createElement('div');
  caixa.className = 'sereia-produtos';

  for (const p of produtos.slice(0, 3)) {
    if (!p || !p.titulo || !p.link) continue;

    // ⚠️ Só links da nossa loja. Um `href` que venha de fora é uma porta aberta.
    let endereco;
    try {
      endereco = new URL(p.link, window.location.origin);
      if (endereco.protocol !== 'https:' || !endereco.hostname.endsWith('ilhadoscosmeticos.pt')) continue;
    } catch {
      continue;
    }

    const cartao = document.createElement('a');
    cartao.className = 'sereia-produto';
    cartao.href = endereco.href;
    cartao.target = '_blank';
    cartao.rel = 'noopener noreferrer';

    if (p.imagem) {
      const foto = document.createElement('img');
      foto.className = 'sereia-produto-foto';
      foto.src = p.imagem;
      foto.alt = '';
      foto.loading = 'lazy';
      cartao.appendChild(foto);
    } else {
      const vazio = document.createElement('span');
      vazio.className = 'sereia-produto-foto';
      vazio.setAttribute('aria-hidden', 'true');
      cartao.appendChild(vazio);
    }

    const texto = document.createElement('span');
    texto.className = 'sereia-produto-texto';

    const nome = document.createElement('span');
    nome.className = 'sereia-produto-nome';
    nome.textContent = p.titulo;
    texto.appendChild(nome);

    const preco = document.createElement('span');
    preco.className = 'sereia-produto-preco';
    // ⛔ «14,19€», sem espaço, igual ao checkout (ordem do Silva, 09/10/2026).
    const emEuros = (n) => n.toFixed(2).replace('.', ',') + '€';

    if (p.esgotado) {
      const marca = document.createElement('span');
      marca.className = 'sereia-produto-esgotado';
      marca.textContent = 'Esgotado';
      preco.appendChild(marca);
    } else if (typeof p.precoMin !== 'number') {
      preco.textContent = 'Ver na loja';
    } else {
      // ⚠️ 44 produtos do catálogo têm tamanhos com preços diferentes: esses mostram-se
      // como "desde", senão a cliente vê um preço e paga outro no carrinho.
      const temIntervalo = typeof p.precoMax === 'number' && p.precoMax !== p.precoMin;
      const agora = document.createElement('b');
      agora.className = 'sereia-preco-agora';
      agora.textContent = (temIntervalo ? 'desde ' : '') + emEuros(p.precoMin);
      preco.appendChild(agora);

      // ⛔⛔ RISCADO E PVPR NÃO SÃO A MESMA COISA.
      //
      //   riscado → cortámos o NOSSO preço. Risca-se, e a poupança pode dizer-se.
      //   PVPR    → preço do FABRICANTE, que nunca praticámos. ⛔ NUNCA se risca e ⛔ nunca
      //             leva percentagem: riscá-lo era afirmar uma descida que não houve.
      //
      // Ver as memórias `ilha-pvpr` e `etiqueta-pvpr-super-preco`.
      if (typeof p.riscado === 'number' && p.riscado > p.precoMin) {
        const velho = document.createElement('s');
        velho.className = 'sereia-preco-riscado';
        velho.textContent = emEuros(p.riscado);
        preco.appendChild(velho);

        // ⚠️ A MESMA CONTA DA FICHA DE PRODUTO, de propósito:
        //   (compare_at - price) * 100 / compare_at, arredondado  (product.ilha.liquid:871)
        // Se a bolha arredondasse de outra maneira, dizia -29% ao lado de uma ficha que diz
        // POUPA 30%, e a cliente via a loja a desmentir-se a si própria.
        // ⛔ PARA BAIXO, como a ficha e como toda a casa (`desconto-arredonda-se-para-baixo`).
        // ⚠️ Estava `Math.round`, e isso punha o cartão a dizer 45% onde o texto da Sereia dizia
        // 44%: a mesma bolha a desmentir-se. A Proa confirmou a 09/10/2026 que a ficha usa
        // `floor` nos dois sítios (Liquid e JS). Medido: 39 dos 181 produtos com riscado mudavam
        // de percentagem entre as duas contas.
        const poupa = Math.floor(((p.riscado - p.precoMin) * 100) / p.riscado);
        if (poupa > 0) {
          const selo = document.createElement('span');
          selo.className = 'sereia-preco-poupa';
          // ⛔ AS MESMAS PALAVRAS DA FICHA: `POUPA 30% (−2,70€)`.
          // ⚠️ Sem espaço antes do euro desde 09/10/2026, como tudo o resto da casa.
          // Ver `product.ilha.liquid:875`. A cliente carrega no cartão e cai na ficha; ver
          // "-30%" aqui e "POUPA 30%" ali é a loja a falar com duas vozes.
          // ⚠️ O sinal é o menos verdadeiro (−, U+2212), como no tema, não um hífen.
          const poupanca = (p.riscado - p.precoMin).toFixed(2).replace('.', ',');
          selo.textContent = 'POUPA ' + poupa + '% (\u2212' + poupanca + '\u20AC)';
          preco.appendChild(selo);
        }
      } else if (typeof p.pvpr === 'number' && p.pvpr > p.precoMin) {
        const marca = document.createElement('span');
        marca.className = 'sereia-preco-pvpr';
        // ⛔ Sem <s> e sem percentagem, de propósito.
        marca.textContent = emEuros(p.pvpr) + ' PVPR';
        preco.appendChild(marca);
      }
    }
    texto.appendChild(preco);
    cartao.appendChild(texto);

    const ver = document.createElement('span');
    ver.className = 'sereia-produto-ver';
    ver.textContent = p.esgotado ? 'Ver' : 'Comprar';
    cartao.appendChild(ver);

    caixa.appendChild(cartao);
  }

  if (caixa.children.length === 0) return;
  c.appendChild(caixa);
  c.scrollTop = c.scrollHeight;
}

function mostrarSugestoes() {
  const c = document.getElementById('sereia-mensagens');
  if (!c) return;
  const d = document.createElement('div');
  d.className = 'sereia-sugestoes';
  d.innerHTML = SUGESTOES.map(s => `<button class="sereia-sugestao" type="button">${s}</button>`).join('');
  c.appendChild(d);
  d.querySelectorAll('.sereia-sugestao').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const en = document.getElementById('sereia-entrada');
      if (en) { en.value = e.target.textContent; ajustarAltura(); en.focus(); }
      d.remove();
    });
  });
  c.scrollTop = c.scrollHeight;
}

function mostrarEscreve() {
  const c = document.getElementById('sereia-mensagens');
  if (!c) return;
  const d = document.createElement('div');
  d.id = 'sereia-escreve';
  d.className = 'sereia-msg sereia-msg--sereia';
  d.innerHTML = '<div class="sereia-escreve"><span class="sereia-ponto"></span><span class="sereia-ponto"></span><span class="sereia-ponto"></span></div>';
  c.appendChild(d);
  c.scrollTop = c.scrollHeight;
}
function removerEscreve() { document.getElementById('sereia-escreve')?.remove(); }

/**
 * O carrinho que a cliente tem no site, para a equipa o ver no balcão se a conversa lhe chegar.
 *
 * ⛔ SÓ COM CONSENTIMENTO. Pergunta-se à API de privacidade do Shopify, que é o banner de
 * cookies do site. Medido a 10/09/2026 em ilhadoscosmeticos.pt: antes de a visitante escolher,
 * analyticsProcessingAllowed() dá false, e é isso que se respeita. Sem a API, sem escolha ou
 * com recusa, não se lê nada e manda-se null.
 *
 * ⚠️ Nunca parte a pergunta: se o carrinho falhar, a pergunta segue sem ele.
 * ⚠️ Os preços do /cart.js vêm em CÊNTIMOS (medido: 699 para 6,99 €), e o variant_title vem
 * null quando o produto só tem uma variante.
 */
async function carrinhoComConsentimento() {
  try {
    const privacidade = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacidade || typeof privacidade.analyticsProcessingAllowed !== 'function') return null;
    if (privacidade.analyticsProcessingAllowed() !== true) return null;
    // ⚠️ Corre ANTES de a pergunta sair, porque vai no mesmo pedido. Por isso o prazo é curto: o
    // /cart.js é do próprio site e responde depressa, e se demorar a pergunta segue sem ele.
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(1200) });
    if (!r.ok) return null;
    const c = await r.json();
    const itens = Array.isArray(c.items) ? c.items : [];
    return {
      itens: itens.slice(0, 30).map(i => ({
        variante: String(i.variant_id || ''),
        titulo: i.product_title || '',
        opcao: i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : null,
        quantidade: i.quantity,
        precoCentimos: i.final_price
      })),
      totalCentimos: c.total_price
    };
  } catch (e) {
    return null;
  }
}

/**
 * O que se diz à cliente quando a pergunta não deu resposta.
 *
 * ⛔ CADA FALHA TEM A SUA CARA, e nenhuma mente. A regra é a de sempre: o que aconteceu, e o
 * que fazer a seguir. Quem foi travado não é mandado tentar outra vez já, porque não resulta.
 * ⚠️ O texto do servidor, quando vem, é o que se diz: é escrito para a cliente, no `limite.js`.
 * ⚠️ Sem «tu» nem «você», como tudo o que a casa escreve.
 */
function mensagemDaFalha(erro) {
  const estado = Number(erro?.estado) || 0;
  const motivo = typeof erro?.motivo === 'string' ? erro.motivo.trim() : '';

  // O travão. O servidor já explicou porquê, com as palavras certas.
  if (estado === 429) {
    return {
      texto: motivo || 'Houve muitas perguntas seguidas. Daqui a uns minutos dá outra vez.',
      // Um limite do DIA não passa com o tempo: aí vale a pena deixar o contacto.
      ofereceContacto: /hoje|amanh/i.test(motivo),
    };
  }

  // A pergunta não serve como está. Não há nada a esperar: há a corrigir.
  if (estado === 400) {
    return {
      texto: motivo
        ? `${motivo.charAt(0).toUpperCase()}${motivo.slice(1)}.`
        : 'A mensagem não passou. Escreve outra vez, mais curta.',
      ofereceContacto: false,
    };
  }

  // Demorou demasiado. O `AbortSignal.timeout` rebenta com TimeoutError.
  if (erro?.name === 'TimeoutError' || erro?.name === 'AbortError') {
    return {
      texto: 'Demorei demasiado a responder. Envia outra vez, ou deixa o contacto e a equipa responde.',
      ofereceContacto: true,
    };
  }

  // Avaria nossa. Dizer que não se consegue ligar seria culpar a rede dela.
  if (estado >= 500) {
    return {
      texto: 'Houve um problema do nosso lado, não foi nada que tenha sido escrito aqui. Dá outra vez dentro de um minuto, ou deixa o contacto.',
      ofereceContacto: true,
    };
  }

  // Aqui sim: o pedido não chegou a sair.
  return {
    texto: 'Não consegui ligar ao servidor. Dá outra vez dentro de um minuto, ou deixa o contacto.',
    ofereceContacto: true,
  };
}

async function enviar() {
  if (aEspera) return;

  const entrada = document.getElementById('sereia-entrada');
  if (!entrada || !entrada.value.trim()) return;

  const pergunta = entrada.value.trim();
  entrada.value = '';
  ajustarAltura();

  mostrarMensagem(pergunta, 'cliente');

  aEspera = true;
  mostrarEscreve();
  document.getElementById('sereia-botao-enviar')?.setAttribute('disabled', '');

  try {
    const carrinho = await carrinhoComConsentimento();
    const r = await fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ pergunta, conversaId, carrinho, encomenda: pistaDaEncomenda || undefined }), signal: AbortSignal.timeout(TIMEOUT_MS) });
    // ⛔⛔ AQUI MENTIA-SE À CLIENTE. Qualquer resposta que não fosse 2xx virava
    // «não consegui ligar ao servidor»: o servidor tinha respondido, e tinha dito porquê.
    // Quem chegava ao limite de perguntas do dia era mandado tentar outra vez daí a pouco, e
    // tentava, e voltava a falhar, a tarde inteira. (Auditoria de 08/10/2026.)
    if (!r.ok) {
      let motivo = '';
      try {
        const corpo = await r.json();
        motivo = typeof corpo?.erro === 'string' ? corpo.erro : '';
      } catch (e) { /* resposta sem corpo: fica o código */ }
      const falha = new Error(motivo || `${r.status}`);
      falha.estado = r.status;
      falha.motivo = motivo;
      throw falha;
    }
    const d = await r.json();
    removerEscreve();
    if (d.resposta) {
      mostrarMensagem(d.resposta.replace(/[\u2014\u2013]/g, '-'), 'sereia');
      // Os produtos que ela citou, em cartão, logo a seguir ao texto.
      mostrarProdutos(d.produtos);
      if (d.escalou) mostrarContactoEscalada(d.conversaId);
    } else {
      removerEscreve();
      mostrarMensagem('Houve um erro aqui. Envia outra vez, ou deixa o contacto e a equipa responde.', 'sereia');
      mostrarContactoEscalada(conversaId);
    }
    // ⚠️ O servidor diz em que modo respondeu: se mudou no meio da conversa, a bolha aprende sem
    // ter de perguntar outra vez.
    if (typeof d.modo === 'string') { modoRecado = d.modo === 'recado'; acertarAFaixa(); }
    conversaId = d.conversaId || conversaId;
    localStorage.setItem(CHAVE_CONVERSA, conversaId);
  } catch (erro) {
    removerEscreve();
    const { texto, ofereceContacto } = mensagemDaFalha(erro);
    mostrarMensagem(texto, 'sereia');
    if (ofereceContacto) mostrarContactoEscalada(conversaId);
  } finally {
    aEspera = false;
    document.getElementById('sereia-botao-enviar')?.removeAttribute('disabled');
    entrada?.focus();
  }
}

function mostrarContactoEscalada(idConversa) {
  const container = document.getElementById('sereia-mensagens');
  if (!container) return;

  if (document.getElementById('sereia-escala')) return;

  const div = document.createElement('div');
  div.id = 'sereia-escala';
  div.className = 'sereia-escalada';

  const html = `
    <div class="sereia-escala-msg">${modoRecado
      ? 'Para a equipa poder responder, deixa aqui o contacto.'
      : 'Vou passar esta pergunta a alguém da nossa equipa. Obrigada pela paciência.'}</div>
    <div class="sereia-escala-contacto">
      <label for="sereia-contacto-input" class="sereia-escala-label">Deixa aqui o email ou o telemóvel e alguém da equipa responde:</label>
      <div class="sereia-escala-input-group">
        <input
          type="text"
          id="sereia-contacto-input"
          class="sereia-escala-input"
          placeholder="email ou telemóvel"
          aria-label="Email ou telemóvel"
        />
        <button class="sereia-escala-enviar" id="sereia-contacto-enviar" aria-label="Enviar contacto">→</button>
      </div>
      <p class="sereia-escala-opcional">Sem problema. Dá também pelo email da loja, apoio@ilhadoscosmeticos.pt.</p>
    </div>
  `;

  div.innerHTML = html;
  container.appendChild(div);

  // ⚠️ O POLLING ARRANCA AQUI, ao escalar, e nao quando a cliente deixa o contacto.
  // Antes so arrancava depois de ela dar o email, e por isso quem nao quisesse dar
  // NUNCA via a resposta, mesmo com alguem a responder-lhe pelo painel. E e precisamente
  // essa cliente que so pode ser ouvida pelo chat, porque nao ha outro sitio onde a achar.
  iniciarPollingRespostas(idConversa);

  const botaoEnviar = div.querySelector('#sereia-contacto-enviar');
  const input = div.querySelector('#sereia-contacto-input');
  botaoEnviar?.addEventListener('click', () => {
    const contacto = input.value.trim();
    if (contacto) {
      enviarContacto(contacto, idConversa);
    }
  });

  input?.addEventListener('keypress', (e) => {
    if (e.key === 'Enter') {
      const contacto = input.value.trim();
      if (contacto) {
        enviarContacto(contacto, idConversa);
      }
    }
  });

  const scroll = container;
  scroll.scrollTop = scroll.scrollHeight;
}

async function enviarContacto(contacto, idConversa) {
  const div = document.getElementById('sereia-escala');
  if (!div) return;
  const input = div.querySelector('#sereia-contacto-input');
  const botao = div.querySelector('#sereia-contacto-enviar');
  if (input) input.setAttribute('disabled', '');
  if (botao) botao.setAttribute('disabled', '');
  try {
    const res = await fetch('/apps/sereia/contacto', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ conversaId: idConversa, contacto }), signal: AbortSignal.timeout(TIMEOUT_MS) });
    if (res.ok) {
      // ⛔ FICA-SE COM O IDENTIFICADOR QUE O SERVIDOR DEVOLVE. Quando a primeira pergunta falha,
      // o que a bolha tem e um identificador feito no browser, que o servidor nao reconhece: o
      // contacto abre um pedido NOVO, com outro identificador. Sem o adoptar aqui, a bolha ficava
      // a perguntar pelas respostas do antigo e a resposta da equipa nunca lhe aparecia.
      let idQueFicou = idConversa;
      try {
        const d = await res.json();
        if (d && typeof d.conversaId === 'string' && d.conversaId) {
          idQueFicou = d.conversaId;
          conversaId = d.conversaId;
          localStorage.setItem(CHAVE_CONVERSA, conversaId);
        }
      } catch (e) { /* resposta sem corpo: segue com o que tinha */ }
      const contactoDiv = div.querySelector('.sereia-escala-contacto');
      if (contactoDiv) contactoDiv.innerHTML = '<p class="sereia-escala-confirmacao">✓ Obrigada. Alguém da equipa responde em breve.</p>';
      // Começar a fazer polling de respostas
      iniciarPollingRespostas(idQueFicou);
    } else throw new Error(`${res.status}`);
  } catch (err) {
    mostrarMensagem('Não consegui guardar o contacto. Dá outra vez, ou escreve para apoio@ilhadoscosmeticos.pt.', 'sereia');
    if (input) input.removeAttribute('disabled');
    if (botao) botao.removeAttribute('disabled');
  }
}

function iniciarPollingRespostas(idConversa) {
  // Parar qualquer polling anterior
  if (pollingRespostas) clearInterval(pollingRespostas);

  inicioPollingRespostas = Date.now();
  ultimasRespostasLidas = [];

  // ⚠️ PERGUNTA JA, e nao daqui a 15 segundos.
  // O `setInterval` so dispara ao fim do primeiro intervalo. Sem esta linha, uma cliente que
  // volte ao site DEPOIS de alguem lhe ter respondido fica 15 segundos a olhar para o nada,
  // com a resposta ja escrita a espera dela do outro lado.
  if (!document.hidden) verificarNovasRespostas(idConversa);

  // ⚠️ E quando ela volta ao separador, tambem se pergunta logo. O ciclo salta enquanto a aba
  // esta escondida (e bem, senao cada separador aberto da loja batia ao servidor o dia todo),
  // mas ao voltar nao se espera pelo proximo intervalo.
  if (!aoVoltarAoSeparador) {
    aoVoltarAoSeparador = () => {
      if (!document.hidden && pollingRespostas) verificarNovasRespostas(idConversa);
    };
    document.addEventListener('visibilitychange', aoVoltarAoSeparador);
  }

  pollingRespostas = setInterval(() => {
    // Parar se passou 30 minutos
    if (Date.now() - inicioPollingRespostas > MAX_TEMPO_ESPERA_RESPOSTAS_MS) {
      clearInterval(pollingRespostas);
      pollingRespostas = null;
      return;
    }

    // Parar se o separador está escondido (documento invisível)
    if (document.hidden) {
      return;
    }

    // Verificar novas respostas
    verificarNovasRespostas(idConversa);
  }, INTERVALO_RESPOSTAS_MS);
}

function pararPollingRespostas() {
  if (pollingRespostas) {
    clearInterval(pollingRespostas);
    pollingRespostas = null;
  }
}

async function verificarNovasRespostas(idConversa) {
  try {
    const res = await fetch(ENDPOINT_RESPOSTAS + '?conversaId=' + encodeURIComponent(idConversa), {
      method: 'GET',
      signal: AbortSignal.timeout(TIMEOUT_MS),
    });

    if (!res.ok) return;

    const dados = await res.json();
    const respostas = Array.isArray(dados.respostas) ? dados.respostas : [];

    // Mostrar respostas novas
    for (const resposta of respostas) {
      // Verificar se já foi mostrada (simplificado: usar timestamp)
      const chave = 'resposta_' + (resposta.ts || resposta.quemResponde);
      if (!ultimasRespostasLidas.includes(chave)) {
        ultimasRespostasLidas.push(chave);
        mostrarRespostaDoOperador(resposta);
      }
    }
  } catch (err) {
    // Ignorar erros de rede silenciosamente
  }
}


function mostrarRespostaDoOperador(resposta) {
  const c = document.getElementById('sereia-mensagens');
  if (!c) return;

  const div = document.createElement('div');
  div.className = 'sereia-msg sereia-msg--operador';

  // ⛔ Tudo por `textContent`: o nome e o texto vêm do servidor, e texto não se cola como HTML.
  const quem = document.createElement('div');
  quem.style.cssText = 'font-size: 12px; color: rgba(0,0,0,.5); margin-bottom: 4px;';
  quem.textContent = (resposta.quemResponde || 'Equipa') + ', da Ilha dos Cosméticos';
  div.appendChild(quem);

  // ⚠️ Uma resposta só com produtos não tem texto: fica quem responde e os cartões, sem bolha vazia.
  if (typeof resposta.texto === 'string' && resposta.texto.trim().length > 0) {
    const texto = document.createElement('div');
    texto.textContent = resposta.texto;
    div.appendChild(texto);
  }
  c.appendChild(div);

  // Os produtos que a equipa juntou: o MESMO cartão dos produtos que a Sereia cita, com o preço de hoje.
  if (Array.isArray(resposta.cartoes) && resposta.cartoes.length > 0) {
    mostrarProdutos(resposta.cartoes);
  }

  c.scrollTop = c.scrollHeight;
  atualizarUltimaUtilizacao();
}
function escaparHtmlWidget(texto) {
  if (!texto) return '';
  return String(texto)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function ajustarAltura() {
  const e = document.getElementById('sereia-entrada');
  if (e) { e.style.height = 'auto'; e.style.height = Math.min(e.scrollHeight, 80) + 'px'; }
}

function gerarId() { return 'sereia-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9); }

function iniciarArrasto(e) {
  pontoInicial = { x: e.clientX, y: e.clientY };
  emArrasto = false; e.currentTarget.setPointerCapture(e.pointerId);
}

function arrastarBolha(e) {
  if (e.buttons === 0) { emArrasto = false; return; }
  const d = Math.sqrt(Math.pow(e.clientX - pontoInicial.x, 2) + Math.pow(e.clientY - pontoInicial.y, 2));
  if (d > 8) {
    emArrasto = true;
    const b = document.getElementById('sereia-botao-bolha');
    if (!b) return;
    const x = Math.max(0, Math.min(window.innerWidth - 56, e.clientX - 28));
    const y = Math.max(0, Math.min(window.innerHeight - 56, e.clientY - 28));
    b.style.left = x + 'px';
    b.style.top = y + 'px';
    b.style.right = 'auto';
    b.style.bottom = 'auto';
    posicaoBolha = { x, y };
    mostrarEtiquetaAjudaSeForPrimeira();
  }
}

function terminarArrasto(e) {
  if (emArrasto && posicaoBolha.x !== undefined && posicaoBolha.y !== undefined) {
    guardarPosicaoBolha();
    ultimoArrastoEm = Date.now();
  }
  emArrasto = false;
}

function mostrarEtiquetaAjudaSeForPrimeira() {
  if (localStorage.getItem(CHAVE_PRIMEIRO_ARRASTO)) return;
  const bolha = document.getElementById('sereia-botao-bolha');
  if (!bolha) return;
  let etiqueta = document.getElementById('sereia-etiqueta-ajuda');
  if (!etiqueta) {
    etiqueta = document.createElement('div');
    etiqueta.id = 'sereia-etiqueta-ajuda';
    etiqueta.className = 'sereia-etiqueta-ajuda';
    etiqueta.textContent = 'Arrasta para onde der mais jeito';
    bolha.parentElement.appendChild(etiqueta);
    setTimeout(() => etiqueta.classList.add('sereia-etiqueta-visivel'), 10);
    localStorage.setItem(CHAVE_PRIMEIRO_ARRASTO, 'true');
    setTimeout(() => { etiqueta.classList.remove('sereia-etiqueta-visivel'); setTimeout(() => etiqueta.remove(), 300); }, 3000);
  }
}

function guardarPosicaoBolha() {
  localStorage.setItem(CHAVE_POSICAO_BOLHA, JSON.stringify({ x: (posicaoBolha.x / window.innerWidth) * 100, y: (posicaoBolha.y / window.innerHeight) * 100 }));
}

function restaurarPosicaoBolha() {
  const g = localStorage.getItem(CHAVE_POSICAO_BOLHA);
  if (!g) return;
  try {
    const p = JSON.parse(g);
    const b = document.getElementById('sereia-botao-bolha');
    if (!b) return;
    let x = Math.max(8, Math.min(window.innerWidth - 64, (p.x / 100) * window.innerWidth));
    let y = Math.max(8, Math.min(window.innerHeight - 64, (p.y / 100) * window.innerHeight));
    b.style.left = x + 'px';
    b.style.top = y + 'px';
    b.style.right = 'auto';
    b.style.bottom = 'auto';
    posicaoBolha = { x, y };
  } catch (e) {}
}

function ajustarPosicaoBolhaNoRedimensionar() {
  if (!posicaoBolha.x) return;
  const b = document.getElementById('sereia-botao-bolha');
  if (!b) return;
  const x = Math.max(8, Math.min(window.innerWidth - 64, posicaoBolha.x));
  const y = Math.max(8, Math.min(window.innerHeight - 64, posicaoBolha.y));
  b.style.left = x + 'px';
  b.style.top = y + 'px';
  posicaoBolha = { x, y };
  guardarPosicaoBolha();
}

function injetarCss() {
  const css = `
/* ═══════════════════════════════════════════════════════════════════════════
   A SEREIA, DO LADO DA CLIENTE.
   ⛔ AS CORES SÃO AS DO SITE, copiadas do "ilha-pdp.css". Não se escolhem aqui.
   A cliente sai da conversa e entra na ficha do produto: se alguma coisa mudar de cor pelo
   caminho, deixa de parecer a mesma loja.
     --rox #9727B3 · --sale #d81f26 · --mut #6b7280 · --ink #20242a · --line #eceaf1
     --soft #f7f4fb · promoção: fundo #ffe4e9
   ⛔ SEM MODO ESCURO, de propósito: a loja é sempre clara e a bolha vive dentro dela.
   ⛔ E sem uma única dependência. Este ficheiro entra no tema da Shopify, e o que não
      tem dependências é o que não se parte. Já houve uma versão que pedia o CSS a um
      endereço que o servidor não servia, e a bolha ficava invisível sem dar erro nenhum.
   ═══════════════════════════════════════════════════════════════════════════ */

/* ⛔ A ARMADURA CONTRA O CSS DO TEMA.
   Este widget vive DENTRO da folha de estilos da loja, e a loja não sabe que ele existe.
   Medido a 09/09/2026 no tema V15: o tema declara \"button{font-family:Helvetica;
   text-transform:capitalize;line-height:30px}\" e \"h2{letter-spacing:-.15px}\" no PRÓPRIO
   elemento. Uma declaração no elemento ganha sempre a uma herdada, por isso as sugestões
   saíam "Que Produtos Tenho Para Cabelo Cacheado?" e a letra não era a nossa.
   ⚠️ O \"!important\" aqui não é preguiça: é a única forma de não depender do que um tema
   futuro venha a escrever. As regras próprias vêm A SEGUIR e voltam a ganhar, porque com a
   mesma força e a mesma especificidade ganha a última. */
.sereia-bolha,.sereia-etiqueta-ajuda,.sereia-ecra,.sereia-ecra *,
.sereia-ecra *::before,.sereia-ecra *::after{
  font-family:"Plus Jakarta Sans",-apple-system,BlinkMacSystemFont,"Segoe UI",system-ui,sans-serif !important;
  text-transform:none !important;
  letter-spacing:normal !important;
  font-style:normal !important;
  text-decoration:none !important;
  text-shadow:none !important;
  box-sizing:border-box !important;
  line-height:1.5 !important;
  float:none !important;
  max-width:none;
  min-width:0}

.sereia-bolha{position:fixed;bottom:20px;right:20px;z-index:2147482999;width:56px;height:56px;
  border-radius:50%;background:#9727B3;color:#fff;border:0;cursor:pointer;display:flex;
  align-items:center;justify-content:center;padding:0;touch-action:none;
  -webkit-tap-highlight-color:transparent;
  box-shadow:0 6px 20px rgba(151,39,179,.34),0 2px 6px rgba(26,20,32,.12);
  transition:transform .18s ease,box-shadow .18s ease}
.sereia-bolha:hover{transform:translateY(-2px);box-shadow:0 10px 26px rgba(151,39,179,.4)}
.sereia-bolha:active{transform:scale(.96)}
.sereia-bolha:focus-visible{outline:none;box-shadow:0 0 0 3px rgba(151,39,179,.35),0 6px 20px rgba(151,39,179,.34)}
.sereia-bolha[hidden]{display:none}
.sereia-bolha svg{width:24px;height:24px;display:block}

.sereia-etiqueta-ajuda{position:fixed;bottom:88px;right:20px;z-index:2147482998;background:#20242a;
  color:#fff;padding:8px 13px;border-radius:10px;font-size:13px;font-weight:600;white-space:nowrap;
  opacity:0;transform:translateY(4px);transition:opacity .25s,transform .25s;pointer-events:none;
  box-shadow:0 4px 14px rgba(26,20,32,.18)}
.sereia-etiqueta-visivel{opacity:1;transform:translateY(0)}

/* ⚠️ O ecrã: no telemóvel ocupa tudo, no computador é um painel de canto.
   Antes tinha \"inset:0\" e nenhuma media query, e tapava a loja inteira num portátil. */
/* ⛔ NO TELEMÓVEL É UMA FOLHA, NÃO O ECRÃ TODO.
   Era \`inset:0;height:100dvh\`, e tapava a loja inteira. Pedido do Silva a 03/10/2026:
   *«queremos uma que não tampe a tela toda, é o que todos os outros programas utilizam»*.
   Fica encostada em baixo, com os cantos de cima redondos, a deixar ver a loja por trás.
   ⛔⛔ E A ALTURA VEM DO \`visualViewport\`, não do \`dvh\`. No iPhone o teclado NÃO encolhe o
   \`dvh\` (o \`dvh\` serve para a barra do Safari aparecer e desaparecer), por isso o painel ficava
   com o ecrã todo, o teclado subia por cima, e a caixa de escrever ia parar debaixo dele. O
   \`--sereia-fundo\` é o que o teclado tapa, e levanta a folha para cima dele. */
.sereia-ecra{position:fixed;left:0;right:0;bottom:var(--sereia-fundo,0px);top:auto;
  z-index:2147483001;background:#faf8fc;color:#20242a;
  display:flex;flex-direction:column;font-size:16px;line-height:1.5;overflow:hidden;
  max-width:100vw;height:var(--sereia-altura,86dvh);max-height:100dvh;
  border-radius:18px 18px 0 0;box-shadow:0 -10px 40px rgba(26,20,32,.22);
  font-family:"Plus Jakarta Sans",-apple-system,BlinkMacSystemFont,"Segoe UI",system-ui,sans-serif}
.sereia-ecra[hidden]{display:none}
.sereia-ecra *{box-sizing:border-box}

.sereia-cabecalho{flex:none;display:flex;align-items:center;justify-content:space-between;gap:10px;
  padding:13px 15px;background:#fff;border-bottom:1px solid #eceaf1}
.sereia-marca{display:flex;align-items:center;gap:10px;min-width:0}
.sereia-gota{width:32px;height:32px;flex:none;border-radius:10px;background:#9727B3;display:flex;
  align-items:center;justify-content:center}
.sereia-gota svg{width:16px;height:16px;display:block}
.sereia-titulo{margin:0;font-size:15px;font-weight:700;line-height:1.25 !important;letter-spacing:-.01em !important}
.sereia-subtitulo{margin:0;font-size:12px;color:#6b7280;line-height:1.3 !important}
.sereia-botoes-cabecalho{display:flex;gap:6px;align-items:center;flex:none}
.sereia-aumentar,.sereia-apagar,.sereia-fechar{width:36px;height:36px;flex:none;border:0;
  border-radius:10px;background:#f7f4fb;color:#6b7280;cursor:pointer;display:flex;align-items:center;
  justify-content:center;font-size:16px;padding:0;-webkit-tap-highlight-color:transparent;
  transition:background .15s,color .15s}
.sereia-aumentar:hover,.sereia-apagar:hover,.sereia-fechar:hover{background:#e3dfec;color:#20242a}
.sereia-aumentar:focus-visible,.sereia-apagar:focus-visible,.sereia-fechar:focus-visible,
.sereia-enviar:focus-visible,.sereia-sugestao:focus-visible,.sereia-entrada:focus-visible{
  outline:none;box-shadow:0 0 0 3px rgba(151,39,179,.28)}
.sereia-aumentar{display:none}

/* ⚠️ O aviso de IA é obrigação legal (AI Act, artigo 50). Fica fixo no topo, nunca rola
   para fora, e não se esconde nem se encolhe. */
.sereia-aviso{flex:none;display:flex;align-items:center;justify-content:center;gap:7px;
  padding:9px 14px;background:#F3E8F7;color:#7A1F92;font-size:12.5px;font-weight:600;
  border-bottom:1px solid #EBDCF2}
.sereia-aviso svg{width:13px;height:13px;flex:none;display:block}

.sereia-corpo{display:flex;flex:1;min-height:0;flex-direction:column}
.sereia-mensagens{flex:1;min-width:0;min-height:0;overflow-y:auto;padding:14px 15px;display:flex;
  flex-direction:column;gap:10px;-webkit-overflow-scrolling:touch}

.sereia-msg{max-width:88% !important;padding:10px 13px;border-radius:14px;word-wrap:break-word;
  overflow-wrap:anywhere;font-size:14.5px;line-height:1.5}
.sereia-msg--cliente{align-self:flex-end;background:#9727B3;color:#fff;border-bottom-right-radius:5px}
.sereia-msg--sereia{align-self:flex-start;background:#fff;border:1px solid #eceaf1;
  border-bottom-left-radius:5px}
/* Quem responde é uma pessoa da equipa: verde, e com o nome dela por cima. */
.sereia-msg--operador{align-self:flex-start;background:#E4F2EB;color:#17794A;
  border:1px solid rgba(23,121,74,.22);border-bottom-left-radius:5px}
.sereia-quem{display:block;font-size:10.5px;font-weight:700;text-transform:uppercase !important;
  letter-spacing:.06em !important;opacity:.85;margin-bottom:3px;line-height:1.4 !important}

.sereia-sugestoes{display:flex;flex-direction:column;gap:8px;margin:4px 0}
.sereia-sugestao{width:100%;padding:11px 13px;border:1px solid #eceaf1;border-radius:12px;
  background:#fff;color:#20242a;font-size:14px;font-weight:500;font-family:inherit;cursor:pointer;
  text-align:left;min-height:44px;transition:border-color .15s,background .15s;
  -webkit-tap-highlight-color:transparent}
.sereia-sugestao:hover{border-color:#9727B3;background:#FCF7FD}
.sereia-sugestao:active{background:#F3E8F7}

/* ⚠️ O produto vai em CARTÃO, com preço e um sítio para carregar. Ia como texto corrido no
   meio de uma frase, e a cliente tinha de o ir procurar outra vez à loja. */
.sereia-produtos{display:flex;flex-direction:column;gap:8px;align-self:flex-start;max-width:94% !important;
  width:100%}
.sereia-produto{display:flex;align-items:center;gap:11px;padding:10px 11px;background:#fff;
  border:1px solid #eceaf1;border-radius:13px;text-decoration:none;color:inherit;
  transition:border-color .15s,box-shadow .15s;-webkit-tap-highlight-color:transparent}
.sereia-produto:hover{border-color:#9727B3;box-shadow:0 2px 10px rgba(151,39,179,.1)}
/* O lugar da foto, para os 36 produtos que ainda não a têm: cinzento do site, discreto. */
.sereia-produto-foto{width:44px;height:44px;flex:none;border-radius:10px;background:#f7f4fb;border:1px solid #eceaf1;
  object-fit:cover;display:block}
.sereia-produto-texto{min-width:0;flex:1}
.sereia-produto-nome{display:block;font-size:14px;font-weight:600;line-height:1.3 !important;
  overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;
  -webkit-box-orient:vertical}
.sereia-produto-preco{display:block;font-size:13px;color:#6b7280;margin-top:2px;
  font-variant-numeric:tabular-nums}
.sereia-produto-esgotado{color:#C02626;font-weight:600}
.sereia-produto-preco{display:flex !important;align-items:baseline;flex-wrap:wrap;gap:6px}
/* ".price .now{color:var(--sale);font-weight:800}" — no site o preço é sempre vermelho,
   com promoção ou sem ela. É assim que a cliente o reconhece quando chega à ficha. */
.sereia-preco-agora{font-size:14px;font-weight:800;color:#d81f26}
/* ⛔ Só o RISCADO leva o traço. O PVPR nunca. */
/* ".price .was{color:var(--mut);text-decoration:line-through}" */
.sereia-preco-riscado{font-size:12.5px;color:#6b7280;text-decoration:line-through !important}
/* ⛔ AS CORES SÃO AS DO SITE, copiadas do "ilha-pdp.css", não escolhidas aqui.
   A cliente sai da conversa e entra na ficha do produto: se a etiqueta mudar de cor pelo
   caminho, deixa de parecer a mesma loja. O tema tem esta lição escrita no próprio ficheiro:
   "a loja tinha dois vermelhos de promoção, parecidos o suficiente para ninguém notar e
   diferentes o suficiente para não parecer a mesma mão".
   ".price .save{background:#ffe4e9;color:var(--sale)}" com "--sale:#d81f26". */
.sereia-preco-poupa{font-size:11px;font-weight:800;color:#d81f26;background:#ffe4e9;
  padding:3px 8px;border-radius:999px;line-height:1.4 !important;white-space:nowrap}
/* ".price .itp-pvpr{color:var(--mut)}" com "--mut:#6b7280". ⛔ Sem traço, sem vermelho. */
.sereia-preco-pvpr{font-size:12px;color:#6b7280}
.sereia-produto-ver{flex:none;font-size:13.5px;font-weight:600;color:#9727B3;background:#F3E8F7;
  padding:7px 12px;border-radius:9px}

.sereia-escreve{display:flex;gap:5px;align-items:center;height:22px}
.sereia-ponto{width:6px;height:6px;border-radius:50%;background:#6b7280;animation:sereia-pulsa 1.4s infinite}
.sereia-ponto:nth-child(2){animation-delay:.2s}
.sereia-ponto:nth-child(3){animation-delay:.4s}
@keyframes sereia-pulsa{0%,60%,100%{opacity:.3}30%{opacity:1}}
@media (prefers-reduced-motion:reduce){.sereia-ponto{animation:none;opacity:.6}
  .sereia-bolha,.sereia-etiqueta-ajuda,.sereia-produto{transition:none}}

.sereia-escalada{padding:13px 15px;background:#FBF0E0;border:1px solid rgba(138,83,16,.22);
  border-radius:13px;font-size:14px;color:#8A5310;align-self:stretch}
.sereia-escala-msg{padding-bottom:11px;border-bottom:1px solid rgba(138,83,16,.2);margin-bottom:11px}
.sereia-escala-contacto{display:flex;flex-direction:column;gap:8px}
.sereia-escala-label{font-size:14px;color:#20242a;display:block;margin-bottom:6px;font-weight:600}
.sereia-escala-input-group{display:flex;gap:8px;align-items:stretch}
.sereia-escala-input{flex:1;min-width:0;padding:10px 12px;font-size:16px;border:1.5px solid #eceaf1;
  border-radius:11px;background:#fff;font-family:inherit;color:#20242a}
.sereia-escala-input:focus{outline:none;border-color:#9727B3;box-shadow:0 0 0 3px rgba(151,39,179,.28)}
.sereia-escala-enviar{width:44px;height:44px;flex:none;padding:0;border:0;border-radius:11px;
  background:#9727B3;color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;
  font-size:16px;-webkit-tap-highlight-color:transparent}
.sereia-escala-enviar:hover{background:#7a1f92}
.sereia-escala-enviar:disabled{opacity:.5;cursor:not-allowed}
.sereia-escala-opcional{font-size:12.5px;color:#6b7280;margin:0}
.sereia-escala-confirmacao{font-size:14px;color:#17794A;margin:0;padding:6px 0;font-weight:600}
.sereia-vazio{color:#6b7280;font-size:14px;text-align:center;padding:20px}

.sereia-rodape{flex:none;display:flex;gap:9px;padding:12px 14px;background:#fff;
  border-top:1px solid #eceaf1;
  padding-bottom:calc(12px + env(safe-area-inset-bottom))}
/* ⚠️ 16px no campo, nunca menos: abaixo disso o iPhone faz zoom sozinho ao tocar. */
.sereia-entrada{flex:1;min-width:0;padding:11px 14px;font-size:16px;border:1.5px solid #eceaf1;
  border-radius:13px;background:#f7f4fb;font-family:inherit;color:#20242a;resize:none;
  max-height:120px;line-height:1.4}
.sereia-entrada:focus{outline:none;border-color:#9727B3;background:#fff}
.sereia-entrada::placeholder{color:#6b7280}
.sereia-enviar{width:44px;height:44px;flex:none;padding:0;border:0;border-radius:13px;
  background:#9727B3;color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;
  -webkit-tap-highlight-color:transparent;transition:background .15s}
.sereia-enviar:hover{background:#7a1f92}
.sereia-enviar:disabled{opacity:.45;cursor:not-allowed}
.sereia-enviar svg{width:18px;height:18px;display:block}

/* ⚠️ NO COMPUTADOR NÃO SE COME A PÁGINA TODA.
   A partir dos 768px é um painel de canto, por cima da bolha, e o botão de aumentar
   passa a existir. Aumentado continua a ser um painel: nunca volta a ser a página toda. */
@media (min-width:768px){
  /* ⚠️ No computador volta a ser janela, e as medidas do telemóvel não valem aqui. */
  .sereia-ecra{inset:auto;left:auto;top:auto;right:20px;bottom:88px;width:400px;
    height:min(620px,calc(100dvh - 120px));max-height:calc(100dvh - 120px);
    border-radius:18px;border:1px solid rgba(26,20,32,.08);
    box-shadow:0 16px 48px rgba(26,20,32,.18),0 2px 8px rgba(26,20,32,.06)}
  .sereia-aumentar{display:flex}
  .sereia-ecra--grande{width:min(560px,calc(100vw - 40px));height:min(820px,calc(100dvh - 120px))}
  .sereia-rodape{padding-bottom:12px}
}
`;
  const style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', inicializar);
} else {
  inicializar();
}
